import { render, staticRenderFns } from "./defent_arrange.vue?vue&type=template&id=1a0a8344&"
import script from "./defent_arrange.vue?vue&type=script&lang=js&"
export * from "./defent_arrange.vue?vue&type=script&lang=js&"
import style0 from "./defent_arrange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports